import { EditMaterialUrl, GenaiUrl, imageURl } from "../../../libs/env";
import $ from "jquery";
import html2pdf from "html2pdf.js";


export const DownloadPDFHelper = ({contentRef, answerSheet, optionsSheet, setnoPrintanswers}) => {
  let params = new URL(document.location).searchParams;
  let template_data = params.get("edit_template");
    setnoPrintanswers(true)
    // $(".quiz-detail").addClass("print_mt4");
    $(".newpageContent").addClass("mb-5");
    $(".no-download").addClass("d-none");
    $(".pdf-download").removeClass("d-none");
    $("#footer").removeClass("mx-0 footer-sticky");
    if(template_data === "true")
    {
      $("#scroll").removeClass("template_scroll");
    }
    else{
      $("#scroll").removeClass("question_scroll");
    }
    $("#report_bug").addClass("d-none");
    const content = contentRef.current;
    const answerSheetContent = document.createElement("div");
    const optionsSheetContent = document.createElement("div");
    if (optionsSheet){
      optionsSheetContent.innerHTML =
      `<div class="page-break px-3 mt-3 mb-5"><h1 class="fw-900 fs-4">Options Sheet</h1><div class="pt-4">${optionsSheet}</div></div>`;
      content.appendChild(optionsSheetContent);
    }
    if (answerSheet){
      answerSheetContent.innerHTML =
      `<div class=" px-3"><h1 class="fw-900 fs-4">Answer Sheet</h1><div class="pt-4">${answerSheet}</div></div>`;
      content.appendChild(answerSheetContent);
    }
    const options = {
      margin: [50, 40, 30, 40], // top, right, bottom, left margins
      filename: "download123.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2, useCORS: true},
      jsPDF: { unit: 'pt', format: 'A4' },
    };
    html2pdf()
      .from(content)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        var totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          // set footer to every page
          pdf.setPage(i);
          // set footer font
          pdf.setFontSize(10);
          pdf.setTextColor(0);
          // addImage(imageData, format, x, y, width, height, alias, compression, rotation)
          pdf.addImage(`${imageURl}/quizy_logo.png`, "png", 40, 12, 110,40);
          // this example gets internal pageSize just as an example to locate your text near the borders in case you want to do something like "Page 3 out of 4"
          pdf.text(
            pdf.internal.pageSize.getWidth() - 370,
            pdf.internal.pageSize.getHeight() - 10,
            "This task was generated with quizy.ai"
          );

          // you can add the line separator as an image, consult the docs below to properly set the place of the image
        }
        pdf.save();
        if (optionsSheet){
          content.removeChild(optionsSheetContent);
        }
        if (answerSheet){
          content.removeChild(answerSheetContent);
        }
        if(window.location.pathname.includes(GenaiUrl))
        {
          if(template_data === "true")
          {
            $("#scroll").addClass("template_scroll");
          }
          else{
            $("#scroll").addClass("question_scroll");
          }
          $("#footer").addClass("mx-0 footer-sticky");
        }
        setnoPrintanswers(false)
        $(".pdf-download").addClass("d-none");
        $(".no-download").removeClass("d-none");
        $("#report_bug").removeClass("d-none");
        // $(".quiz-detail").removeClass("print_mt4");
        $(".newpageContent").removeClass("mb-5");
      });
  };

export const DownloadMaterialPDF = ({contentRef}) => {
      $(".no-download").addClass("d-none");
      $("#footer").removeClass("mx-0 footer-sticky");
      $("#scroll").removeClass("question_scroll");
      const content = contentRef.current;
      const options = {
        margin: [50, 40, 30, 40], // top, right, bottom, left margins
        filename: "TeacherMaterial.pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2, useCORS: true},
        jsPDF: { unit: 'pt', format: 'A4' },
      };
      html2pdf()
        .from(content)
        .set(options)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          var totalPages = pdf.internal.getNumberOfPages();
  
          for (let i = 1; i <= totalPages; i++) {
            // set footer to every page
            pdf.setPage(i);
            // set footer font
            pdf.setFontSize(10);
            pdf.setTextColor(0);
            // addImage(imageData, format, x, y, width, height, alias, compression, rotation)
            pdf.addImage(`${imageURl}/quizy_logo.png`, "png", 40, 12, 110,40);
            // this example gets internal pageSize just as an example to locate your text near the borders in case you want to do something like "Page 3 out of 4"
            pdf.text(
              pdf.internal.pageSize.getWidth() - 370,
              pdf.internal.pageSize.getHeight() - 10,
              "This material was generated with quizy.ai"
            );
  
            // you can add the line separator as an image, consult the docs below to properly set the place of the image
          }
          pdf.save(options.filename);
          if(window.location.pathname.includes(EditMaterialUrl))
          {
            $("#scroll").addClass("question_scroll");
            $("#footer").addClass("mx-0 footer-sticky");
          }
          $(".no-download").removeClass("d-none");
        });
    };